export const mutations = {
  addUser (state, user) {
    state.user = user
  },
  setUser (state, user) {
    state.user = user
  },
  addUsers(state, user) {
    state.users = user;
  },
}
